"use strict";

angular.module('app.cessao').factory('lastroReprocessamentoFactory', function ($http) {
    var baseUrl = 'api/Lastro';

    // Função para gerar download do arquivo Excel
    function gerarBlobDownload(data, nomeArquivo) {
        var blob = new Blob([data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
        });

        var url = window.URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = url;
        a.download = nomeArquivo;
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(url);
    }

    // Função para gerar GUID
    function gerarGuid() {
        return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, c =>
            (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
        );
    }

    return {
        // 1. Lista Importações
        listarImportacoes: function (callback, dtInicio, dtTermino) {
            var request = {
                parms: [
                    { name: 'DtInicio', value: dtInicio },
                    { name: 'DtTermino', value: dtTermino }
                ],
                search: ''
            };
            $http.post(appConfig.serviceBase + baseUrl + '/ListaImportacoes', request)
                .then(function (response) {
                    callback.success(response.data);
                }, function (error) {
                    callback.error(error);
                });
        },

        // 2. Upload do Arquivo Excel
        uploadImportacao: function (file, callback) {
            $http({
                method: 'POST',
                url: appConfig.serviceBase + baseUrl + '/ReprocessamentoPropostasBucket',
                headers: { 'Content-Type': undefined },
                transformRequest: function (data) {
                    var formData = new FormData();
                    formData.append('file', data.file);
                    return formData;
                },
                data: { file: file }
            }).then(function (response) {
                // Encaminha SEM interpretar HasError/Errors (controller decide)
                if (callback && callback.success) {
                    callback.success(response.data);
                }
            }, function (error) {
                // Apenas erros HTTP / network vão para callback.error
                if (callback && callback.error) {
                    callback.error(error);
                }
            });
        },

        // 3. Lista Propostas da Remessa
        listarPropostasRemessa: function (arquivoCodigo, callback) {
            var request = {
                parms: [
                    { name: 'ArquivoCodigo', value: arquivoCodigo }
                ],
                search: ''
            };
            $http.post(appConfig.serviceBase + baseUrl + '/ListaPropostasReprocessadas', request)
                .then(function (response) {
                    callback.success(response.data);
                }, function (error) {
                    callback.error(error);
                });
        },

        // 4. Lista Documentos da Proposta
        listarDocumentosProposta: function (codigoProposta, codigoArquivo, pastaOrigem, pastaDestino, callback) {
            var request = {
                parms: [
                    { name: 'CodigoProposta', value: codigoProposta },
                    { name: 'CodigoArquivo', value: codigoArquivo },
                    { name: 'PastaOrigem', value: pastaOrigem },
                    { name: 'PastaDestino', value: pastaDestino },
                ],
                search: ''
            };
            $http.post(appConfig.serviceBase + baseUrl + '/ListaDocumentosReprocessados', request)
                .then(function (response) {
                    callback.success(response.data);
                }, function (error) {
                    callback.error(error);
                });
        },

        // 5. Baixar Excel direto
        baixarExcelGenerico: function (dados, nomeArquivo, columnsMap) {
            var payload = {
                FileName: nomeArquivo.replace('.xlsx', ''),
                ColumnsMap: columnsMap,
                Dados: dados
            };

            return $http.post(appConfig.serviceBase + baseUrl + '/exportar-excel-generico', payload, { responseType: 'arraybuffer' })
                .then(function (response) {
                    gerarBlobDownload(response.data, nomeArquivo);
                    return response.data;
                })
                .catch(function (error) {
                    console.error('Erro ao exportar Excel:', error);
                    alert('Erro ao exportar Excel.');
                    throw error;
                });
        },

        // 6. Baixar Excel Modelo
        baixarModeloExcel: function () {
            return $http.get(appConfig.serviceBase + baseUrl + '/gerar-modelo-excel', { responseType: 'arraybuffer' })
                .then(function (response) {
                    var guid = gerarGuid();
                    var nomeArquivo = guid + ".xlsx";
                    gerarBlobDownload(response.data, nomeArquivo);
                    return response.data;
                })
                .catch(function (error) {
                    console.error('Erro ao baixar modelo Excel:', error);
                    alert('Erro ao baixar modelo Excel.');
                    throw error;
                });
        }
    }
});
